import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { Globals } from "../globals";
import { AuthResponseDTO } from "src/app/models/auth-response.dto";
import { ApiBaseResponseDTO } from "src/app/models/api.base.response";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(
        private httpClient: HttpClient
    ) { }

    login(identifier: string, password: string): Observable<AuthResponseDTO> {
        const params = {
            identifier: identifier,
            password: password
        };

        return this.httpClient.post<AuthResponseDTO>(Globals.apiEndpoint + "auth/sign-in", params)
            .pipe(map(response => {
                return response;
            }));
    }
    superAdminLogin(identifier: string, password: string): Observable<AuthResponseDTO> {
        const params = {
            identifier: identifier,
            password: password
        };

        return this.httpClient.post<AuthResponseDTO>(Globals.superAdminApiEndpoint + "auth/sign-in", params)
            .pipe(map(response => {
                return response;
            }));
    }
    logout(): Observable<any> {
        return this.httpClient.get(
            Globals.apiEndpoint + "auth/sign-out",
            {}
        );
    }
    dummy(dummyResponse: any): Observable<ApiBaseResponseDTO<any>> {

        //return dummyResponse;
        return this.httpClient.post<ApiBaseResponseDTO<any>>(Globals.apiEndpoint + "dummy", dummyResponse)
            .pipe(map(response => {
                return response;
            }));
    }
}